module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-49-min.fe4015ca.jpg";